export default {
  // 按钮
  addConfig: '新增配置',
  searchButton: '查询',
  edit: '修改',
  delete: '删除',

  // 表格列
  configKey: '配置键',
  configValue: '配置值',
  description: '描述',
  status: '状态',
  createTime: '创建时间',
  updateTime: '更新时间',
  operation: '操作',

  // 状态值
  enabled: '启用',
  disabled: '禁用',

  // 弹窗
  addConfigTitle: '新增配置',
  editConfigTitle: '修改配置',

  // 表单字段
  configKeyField: '配置键',
  configKeyPlaceholder: '请输入配置键',
  configValueField: '配置值',
  configValuePlaceholder: '请输入配置值',
  descriptionField: '描述',
  descriptionPlaceholder: '请输入描述',
  statusField: '状态',

  // 开关标签
  enabledText: '启用',
  disabledText: '禁用',

  // 校验提示
  configKeyRequired: '请输入配置键',
  configValueRequired: '请输入配置值',
  descriptionRequired: '请输入描述',

  // 按钮
  cancel: '取消',
  confirm: '确定',

  // 提示消息
  addSuccess: '新增成功',
  editSuccess: '修改成功',
  deleteSuccess: '删除成功',

  // 删除确认
  deleteConfirmTitle: '确认删除',
  deleteConfirmContent: '是否删除"{key}"?',
  deleteConfirm: '删除',
}
